import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=355f2268&scoped=true"
import script from "./scene.vue?vue&type=script&lang=js"
export * from "./scene.vue?vue&type=script&lang=js"
import style0 from "./scene.vue?vue&type=style&index=0&id=355f2268&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f2268",
  null
  
)

export default component.exports